import { Role, UserAccount } from '../api/schemas/schema'

export const decodeToken = (token: any) => {
   if (!token) return null
   const payload = token.split('.')[1]
   return JSON.parse(atob(payload))
}

export const isSystemAdmin = (userAccount: UserAccount) => {
   if (userAccount.role === Role.SystemAdministrator) return true
   return false
}
